import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "datepicker", "month", "year", "days", "blankdays", "datepickerValue"];

  connect() {
    this.MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    this.today = new Date();
    this.month = this.today.getMonth();
    this.year = this.today.getFullYear();
    this.datepickerValue = this.today.toDateString();

    this.updateDatepicker();
  }

  toggleDatepicker() {
    this.datepickerTarget.classList.toggle("hidden");
  }

  updateDatepicker() {
    this.updateMonthYear();
    this.updateDays();
  }

  updateMonthYear() {
    this.monthTarget.textContent = this.MONTH_NAMES[this.month];
    this.yearTarget.textContent = this.year;
  }

  updateDays() {
    let daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
    let dayOfWeek = new Date(this.year, this.month).getDay();

    let blankdaysArray = [];
    for (let i = 1; i <= dayOfWeek; i++) {
      blankdaysArray.push(i);
    }

    let daysArray = [];
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push(i);
    }

    this.blankdaysTarget.innerHTML = blankdaysArray.map(() => `<div class="text-center border p-1 border-transparent text-sm"></div>`).join("");
    this.daysTarget.innerHTML = daysArray.map(date => `
      <div class="mb-1" style="width: 14.28%">
        <div class="p-1 cursor-pointer text-center text-sm rounded-full leading-loose transition ease-in-out duration-100 ${this.isToday(date) ? 'bg-blue-500 text-white' : 'text-gray-700 hover:bg-blue-200'}" data-action="click->date-picker#selectDate" data-date="${date}">
          ${date}
        </div>
      </div>
    `).join("");
  }

  isToday(date) {
    const d = new Date(this.year, this.month, date);
    return this.today.toDateString() === d.toDateString();
  }

  selectDate(event) {
    const date = event.currentTarget.getAttribute("data-date");
    const selectedDate = new Date(this.year, this.month, date);

    // Update the hidden input field with the formatted date (YYYY-MM-DD)
    this.inputTarget.value = `${selectedDate.getFullYear()}-${('0' + (selectedDate.getMonth() + 1)).slice(-2)}-${('0' + selectedDate.getDate()).slice(-2)}`;

    // Update the visible input field with the formatted date string (e.g., "Fri Feb 07 2025")
    this.datepickerValueTarget.value = selectedDate.toDateString();

    // Hide the datepicker
    this.datepickerTarget.classList.add("hidden");
  }

  changeMonth(event) {
    const delta = parseInt(event.currentTarget.getAttribute("data-delta"));
    this.month += delta;
    if (this.month < 0) {
      this.month = 11;
      this.year--;
    } else if (this.month > 11) {
      this.month = 0;
      this.year++;
    }
    this.updateDatepicker();
  }
}
